/**
 * Presentation-layer filter only. This does not enforce purchasing rules.
 * Restricted variants can still be added by posting directly to /cart/add.
 * A Shopify Function will enforce this separately.
 *
 * Filters product JSON for Shopify.OptionSelectors, corrects ?variant=
 * deep links to an allowed variant via history.replaceState, and strips
 * leftover Search & Discovery emulsion filter params when the emulsion
 * facet is omitted (logged-out / D2C, a B2B location locked to one
 * emulsion, or any non-Quick-Order collection; full reload via
 * location.replace). Quick Order keeps the facet for unrestricted B2B.
 */
(function (window) {
  var config = window.AbstraxEmulsionAccess || {};
  var KNOWN = {
    standard: true,
    'whole foods compliant': true,
  };

  function canonicalize(value) {
    return String(value || '')
      .replace(/^\s+|\s+$/g, '')
      .toLowerCase()
      .replace(/standard emulsion/g, 'standard');
  }

  function variantOptionAt(variant, index) {
    if (variant.options && variant.options[index] != null) {
      return variant.options[index];
    }
    return variant['option' + (index + 1)];
  }

  function findEmulsionIndex(product, accessCanon) {
    var variants = product.variants || [];
    if (!variants.length) return -1;
    var optionCount = (product.options || []).length;
    if (!optionCount && variants[0].options) {
      optionCount = variants[0].options.length;
    }
    var i;
    var v;
    var canon;
    for (i = 0; i < optionCount; i++) {
      for (v = 0; v < variants.length; v++) {
        canon = canonicalize(variantOptionAt(variants[v], i));
        if (KNOWN[canon] || (accessCanon && canon === accessCanon)) {
          return i;
        }
      }
    }
    return -1;
  }

  function filterProductJson(product) {
    if (!product) return product;
    var accessCanon = canonicalize(config.access);
    if (!accessCanon || accessCanon === 'all') return product;
    var idx = findEmulsionIndex(product, accessCanon);
    if (idx === -1) return product;
    var clone = {};
    var key;
    for (key in product) {
      if (Object.prototype.hasOwnProperty.call(product, key)) {
        clone[key] = product[key];
      }
    }
    clone.variants = (product.variants || []).filter(function (variant) {
      return canonicalize(variantOptionAt(variant, idx)) === accessCanon;
    });
    return clone;
  }

  /**
    * Search & Discovery filter params are catalog-wide. Drop filter.* keys
    * that name emulsion when the facet is omitted: restricted / D2C visitors
    * everywhere, and unrestricted B2B on every collection except Quick
    * Order. Reloads via location.replace; returns true if a navigation was
    * started. Does not touch emulsion_access_debug (not a filter.* key).
   */
  function isQuickOrderCollection() {
    return /\/collections\/quick-order\/?$/i.test(window.location.pathname || '');
  }

  function stripRestrictedEmulsionFilterParams() {
    if (config.hideEmulsionFacet !== true && isQuickOrderCollection()) return false;
    if (typeof URLSearchParams === 'undefined') return false;
    var params = new URLSearchParams(window.location.search);
    var keysToDelete = [];
    var seen = {};
    params.forEach(function (value, key) {
      var lower = String(key).toLowerCase();
      if (lower.indexOf('filter.') !== 0) return;
      if (lower.indexOf('emulsion') === -1) return;
      if (seen[key]) return;
      seen[key] = true;
      keysToDelete.push(key);
    });
    if (!keysToDelete.length) return false;
    var i;
    for (i = 0; i < keysToDelete.length; i++) {
      params.delete(keysToDelete[i]);
    }
    var query = params.toString();
    var url = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    window.location.replace(url);
    return true;
  }

  function replaceRestrictedVariantUrl() {
    var accessCanon = canonicalize(config.access);
    if (!accessCanon || accessCanon === 'all') return;
    if (typeof URLSearchParams === 'undefined') return;
    var params = new URLSearchParams(window.location.search);
    var vid = params.get('variant');
    if (!vid) return;
    var select = document.getElementById('productSelect');
    if (!select) return;
    var options = select.options;
    var found = false;
    var firstAllowed = '';
    var i;
    for (i = 0; i < options.length; i++) {
      if (options[i].disabled || !options[i].value) continue;
      if (!firstAllowed) firstAllowed = options[i].value;
      if (String(options[i].value) === String(vid)) {
        found = true;
        break;
      }
    }
    if (found || !firstAllowed) return;
    params.set('variant', firstAllowed);
    var query = params.toString();
    var url = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', url);
    }
    select.value = firstAllowed;
    if (typeof window.jQuery === 'function') {
      window.jQuery(select).trigger('change');
    }
  }

  config.filterProductJson = filterProductJson;
  config.canonicalize = canonicalize;
  config.replaceRestrictedVariantUrl = replaceRestrictedVariantUrl;
  config.stripRestrictedEmulsionFilterParams = stripRestrictedEmulsionFilterParams;
  window.AbstraxEmulsionAccess = config;

  if (stripRestrictedEmulsionFilterParams()) {
    return;
  }

  if (
    typeof URLSearchParams !== 'undefined' &&
    new URLSearchParams(window.location.search).get('emulsion_access_debug') === '1'
  ) {
    console.info('[emulsion-access]', config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceRestrictedVariantUrl);
  } else {
    replaceRestrictedVariantUrl();
  }

  document.addEventListener(
    'click',
    function (event) {
      var blocked = event.target.closest(
        '.emulsion-access-checkout-blocked, #CartCheckout[aria-disabled="true"]'
      );
      if (!blocked) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
})(window);
